import React, { Component } from 'react'
import Toggle from 'components/controls/toggle'
import { isTaskInTodos } from 'utils/task'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import Loader from 'components/loader/loader'

import {
	dashboardQuery,
	toggleTimer,
	togglePreference,
	openModal,
	updateTask
} from 'state/actions'

import {
	getUserRoles,
	getCurrentUser,
	getCurrentAccount
} from 'state/selectors'

import {
	openItem,
	isLoadingOtherAccount,
	getStatusName,
	getPrimaryColumnValue,
	getUrl
} from 'utils'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import DashboardTasksTask from './dashboard-tasks-task'

import moment from 'moment'

import { MainContext } from 'context'

class DashboardTasks extends Component {
	toggleOptions = [
		{
			name: 'Upcoming'
		},
		{
			name: 'Recent'
		}
	]

	state = {
		activeTab: 0,
		toggleState: 0,
		selectedItemId: null,
		selectedItemType: null,
		isLoading: false,
		activeTask: null, // for updating statuses
		currentlyOpenTaskId: null,
	}

	statusRefs = {}

	UNSAFE_componentWillMount = _ => {
		this.setState({
			toggleState: this.props.userData.dashboard_task_toggled ? 1 : 0
		})
	}

	componentDidUpdate = prevProps => {
		if (!this.props.accountData || !prevProps.accountData) {
			return
		}

		if (this.props.accountData.id !== prevProps.accountData.id) {
			this.handleFilterChange(this.state.selectedItemId, this.state.selectedItemType)
		}
	}

	toggleState = _ => {
		this.props.togglePreference(this.props.userData, 'dashboard_task')

		this.setState({
			toggleState: !this.state.toggleState
		})
	}

	openItem = (type, project, task = null) => {
		if(type === 'task'){
			return this.setState({
				currentlyOpenTaskId: task.id
			})
		}

		return openItem(this.props, type, project, task)
	}

	addTaskToTodos = (block, task, project) => {
		if (block) {
			return
		}

		const statusId = getPrimaryColumnValue('status', task, project)

		if (statusId !== 3) {
			this.props.createTodo(null, null, _ => { }, task.id)
		}
	}

	setTab = activeTab => {
		this.setState({
			activeTab
		}, _ => {
			if (activeTab) {
				const {
					selectedItemId,
					selectedItemType
				} = this.state

				this.handleFilterChange(selectedItemId, null, selectedItemType == 'team')
			}
		})
	}

	handleFilterChange = (itemId, _, isTeam) => {
		if (!itemId || !this.state.activeTab) {
			return
		}

		const itemType = isTeam ? 'team' : 'person'

		this.setState({
			isLoading: true,
			selectedItemId: itemId,
			selectedItemType: itemType
		})

		this.props.dashboardQuery(itemId, itemType, _ => {
			this.setState({
				isLoading: false
			})
		})
	}

	getTasksByType = type => {
		const {
			activeTab,
			selectedItemType,
			selectedItemId
		} = this.state

		const {
			dashboardQueries,
			upcoming,
			recentlyAdded,
			allTasks,
			userData
		} = this.props

		let tasks = []
		let taskIds = []

		if (!activeTab) {
			switch (type) {
				case 'upcoming':
					taskIds = upcoming
					break
				case 'recentlyAdded':
					taskIds = recentlyAdded
					break
			}
		} else {
			if (dashboardQueries && selectedItemId) {
				const taskCollection = dashboardQueries[`${selectedItemType}_${selectedItemId}`]

				if (taskCollection) {
					switch (type) {
						case 'upcoming':
							taskIds = taskCollection.upcoming ? taskCollection.upcoming : []
							break
						case 'recentlyAdded':
							taskIds = taskCollection.recentlyAdded ? taskCollection.recentlyAdded : []
							break
					}
				}
			}
		}

		taskIds.forEach(taskId => {
			const task = allTasks[taskId]

			if (!task) {
				return
			}

			if (task.dismissals && task.dismissals[userData.id] && (!this.props.type || this.props.type !== 'reporting')) {
				const dismissedMoment = moment(task.dismissals[userData.id])

				if (dismissedMoment.isAfter(moment())) {
					return
				}
			}

			tasks.push(task)
		})

		return tasks
	}

	getProjectFromTask = task => {
		const {
			allMilestones,
			allProjects
		} = this.props

		const milestone = allMilestones[task.milestone_id]

		if (!milestone) {
			return null
		}

		const project = allProjects[milestone.project_id]

		return project ? project : null
	}

	startTiming = task => {
		this.props.toggleTimer(task)
	}

	isTaskCurrentlyTracking = task => {
		const {
			userData,
			allSessions
		} = this.props

		if (!userData || !userData.sessions) {
			return false
		}

		let currentlyTrackedTaskId = null

		userData.sessions.forEach(sessionId => {
			const session = allSessions[sessionId]

			if (session && !session.stopped_at) {
				currentlyTrackedTaskId = session.task_id
			}
		})

		return currentlyTrackedTaskId && currentlyTrackedTaskId == task.id
	}

	getStatusName = (statusId, project) => {
		if (!statusId) {
			return '(No status)'
		}

		const {
			allStatuses
		} = this.props

		return getStatusName(statusId, project, allStatuses)
	}

	isLoadingOtherAccount = _ => {
		const {
			accountData
		} = this.props

		return isLoadingOtherAccount(accountData)
	}

	openStatusModal = (task, isOpen) => {
		this.setState({
			activeTask: !isOpen ? task : null
		})
	}

	clearActiveTask = _ => {
		this.setState({
			activeTask: null
		})
	}

	render() {
		const {
			accountData,
			userData,
			allTodoDays,
			allTodos,
			allProjects,
			allUsers,
			allTeams,
			allMilestones,
			isPremium,
			userRoles,
			type,
			loading,
			openModal,
			project,
			updateTask
		} = this.props

		const isPmOrAdmin = userRoles.pm || userRoles.admin

		const {
			toggleState,
			activeTab,
			selectedItemId,
			selectedItemType,
			activeTask,
			currentlyOpenTaskId
		} = this.state

		let tasks = []
		let isLoading = !!this.state.isLoading

		if (!toggleState) {
			tasks = this.getTasksByType('upcoming')
		} else {
			tasks = this.getTasksByType('recentlyAdded')
		}

		const _isLoadingOtherAccount = this.isLoadingOtherAccount()

		if (_isLoadingOtherAccount) {
			isLoading = true
		}

		let taskObjects = []

		tasks.forEach(task => {
			let shouldPushTask = false

			const taskProject = this.getProjectFromTask(task)
			const endDate = getPrimaryColumnValue('date', task, taskProject)
			const statusId = getPrimaryColumnValue('status', task, taskProject)
			const milestone = allMilestones[task.milestone_id]

			if (!toggleState && (endDate.end) || task.is_quick_task) {
				shouldPushTask = true
			}

			if (toggleState == 1) {
				shouldPushTask = true
			}

			if (!taskProject || statusId === 3 || !milestone) {
				shouldPushTask = false
			}

			if (shouldPushTask) {
				taskObjects.push({
					project: taskProject,
					task,
					milestone
				})
			}
		})

		// sort by due date if 0, by add date if 1
		if (toggleState == 0) {
			taskObjects.sort((a, b) => {
				const aProject = a.project
				const bProject = b.project

				const aDates = getPrimaryColumnValue('date', a.task, aProject)
				const bDates = getPrimaryColumnValue('date', b.task, bProject)

				return (aDates.end || '').localeCompare(bDates.end || '')
			})
		} else {
			taskObjects.sort((a, b) => {
				return b.task.created_at.localeCompare(a.task.created_at)
			})
		}

		// for PMs: filter by person or team.
		const selectablePeople = []
		const selectableTeams = []
		let folderSelectorDropdownClassName = ''

		const allowSeeAllTasks = isPremium && isPmOrAdmin

		let titleTabs = ['My Tasks']

		if (type == 'reporting') {
			titleTabs = ['Priorities']
		} else if (allowSeeAllTasks) {
			titleTabs.push('All Tasks')

			accountData.users.forEach(userId => {
				if (accountData.guestIds.indexOf(userId) == -1) {
					const user = allUsers[userId]

					if (user) {
						selectablePeople.push(user)
					}
				}
			})

			accountData.teams.forEach(teamId => {
				const team = allTeams[teamId]

				if (team) {
					selectableTeams.push(team)
				}
			})

			folderSelectorDropdownClassName = 'folder-selector-dropdown-container'

			if (activeTab == 1) {
				folderSelectorDropdownClassName += ' visible'
			}
		}

		if (isLoading || loading) {
			taskObjects = []
		}

		let emptyTitle
		let emptyContent

		if (type == 'reporting') {
			emptyTitle = `Nothing to show here.`
			emptyContent = `${project.name} has no ${!toggleState ? 'upcoming' : 'recently added'} tasks`
		} else if (!activeTab) {
			emptyTitle = `You're off the hook, ${userData.first_name}!`
			emptyContent = `Any tasks you're assigned to will appear here.`
		} else if (!selectedItemId) {
			emptyTitle = `Select a person or a team.`
			emptyContent = `We'll show their upcoming and recent tasks here.`
		} else if (selectedItemType == 'person') {
			const person = allUsers[selectedItemId]

			emptyTitle = `${person.first_name} has nothing upcoming.`
			emptyContent = `Perhaps you should assign 'em some tasks!`
		} else {
			const team = allTeams[selectedItemId]

			emptyTitle = `${team.name} has nothing upcoming.`
			emptyContent = `They might get a bit bored. Assign them some tasks!`
		}

		return (
			<div>
				<h3 className="widget-title-tabs">
					{titleTabs.map((title, index) => {
						return (
							<button
								key={index}
								className={activeTab == index ? 'active' : null}
								onClick={_ => this.setTab(index)}
							>
								{ title}
							</button>
						)
					})}
				</h3>
				<Toggle
					toggleState={toggleState}
					toggleChangeCallback={this.toggleState}
					toggleOptions={this.toggleOptions}
				/>
				{ allowSeeAllTasks ?
					<div className={folderSelectorDropdownClassName}>
						<DropdownMenu
							isObjects={true}
							selectablePeople={selectablePeople}
							selectableTeams={selectableTeams}
							hasImage={true}
							selectedItemId={selectedItemId}
							selectedItemType={selectedItemType}
							handleChange={this.handleFilterChange}
							parentType="people"
						/>
					</div>
					: null}
				{
					taskObjects.length ?
						<ul
							className="big-task-list headertab-list no-padding"
						>
							{taskObjects.map((data, index) => {
								return (
									<DashboardTasksTask 
										{...data} 
										key={index} 
										isTaskCurrentlyTracking={this.isTaskCurrentlyTracking}
										isTaskInTodos={isTaskInTodos}
										openModal={openModal}
										addTaskToTodos={this.addTaskToTodos}
										context={this.context}
										startTiming={this.startTiming}
										openItem={this.openItem}
										statusRefs={this.statusRefs}
										openStatusModal={this.openStatusModal}
										getStatusName={this.getStatusName}
										clearActiveTask={this.clearActiveTask}
										type={type}
										userData={userData}
										allTodoDays={allTodoDays}
										allTodos={allTodos}
										allTeams={allTeams}
										toggleState={toggleState}
										activeTask={activeTask}
										updateTask={updateTask}
										index={index}
										taskObjects={taskObjects}
										allUsers={allUsers}
										isOpen={currentlyOpenTaskId === data.task.id}
										closeTask={() => {
											this.setState({
												currentlyOpenTaskId: null
											})
										}}
										getUrl={task => getUrl(this.props, 'task', data.project, task)}
									/>
								)
							})}
						</ul>
						:
						<ul className="big-task-list headertab-list no-padding empty">
							{(isLoading || loading) ?
								<Loader
									visible={true}
								/>
								: null
							}
							<li className="list-item empty-banner">
								<h2>
									{emptyTitle}
								</h2>
								<p>
									{emptyContent}
								</p>
								<img src={`${ document.base }/images/decoration/dashboard-tasks-empty${ window.isTkb ? '-tkb' : ''}.png`} />
							</li>
						</ul>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		userRoles: getUserRoles(state),
		allUsers: state.account.entities.users,
		allTeams: state.account.entities.teams,
		allSessions: state.account.entities.sessions,
		allStatuses: state.account.entities.statuses,
		dashboardQueries: state.account.entities.dashboardQuery
	}
}

export default withRouter(connect(mapStateToProps, {
	dashboardQuery,
	toggleTimer,
	togglePreference,
	openModal,
	updateTask
})(DashboardTasks))

DashboardTasks.contextType = MainContext